import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';
import { GknRoutePath } from '../app-routing.enum';
import { AppFooterBrandCopyrightComponent } from './app-footer-brand-copyright/app-footer-brand-copyright.component';
import { AppFooterBrandSocialsComponent } from './app-footer-brand-socials/app-footer-brand-socials.component';
import { AppFooterLanguageTranslatorComponent } from './app-footer-language-translator/app-footer-language-translator.component';

@Component({
    selector: 'app-footer',
    imports: [
        CommonModule,
        AppFooterBrandCopyrightComponent,
        AppFooterLanguageTranslatorComponent,
        AppFooterBrandSocialsComponent,
    ],
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent {
    statusRoute = GknRoutePath.STATUS;
}
